import type { components } from '@aurigaengineering/contracts-admin'
import type { ApiClient } from './client'

export type PracticeImportOutcome = components['schemas']['PracticeImportOutcome']

export interface PracticeApi {
  upload(exam: string, file: File, preview: boolean): Promise<PracticeImportOutcome>
}

export function practiceApi(client: ApiClient): PracticeApi {
  return {
    async upload(exam, file, preview) {
      const form = new FormData()
      form.append('files', file, file.name)
      const { data, error } = await client.POST('/admin/practice/upload', {
        params: { query: { exam, preview } },
        body: form as unknown as string,
        bodySerializer: (body) => body as unknown as FormData,
      })
      if (data) return data
      const problem = error as { detail?: string; title?: string } | undefined
      throw new Error(problem?.detail ?? problem?.title ?? 'The API refused that.')
    },
  }
}
